import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { TermsOfService } from '../TermsOfService';
import { PrivacyPolicy } from '../PrivacyPolicy';

const LegalDialog = ({ label, testId, children }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button className="hover:text-[var(--brand-primary)] transition-colors text-left" data-testid={testId}>
        {label}
      </button>
    </DialogTrigger>
    <DialogContent className="bg-[var(--bg-card)] border-[var(--border-medium)] text-[var(--text-primary)] max-w-2xl">
      <DialogHeader>
        <DialogTitle className="text-2xl font-bold uppercase mb-4">{label}</DialogTitle>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);

export const SiteFooter = () => (
  <footer className="py-12 border-t border-[var(--border-medium)] bg-[var(--bg-page)]/80 backdrop-blur-sm">
    <div className="container mx-auto px-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="text-center md:text-left">
          <div className="font-bold text-lg uppercase tracking-wider text-[var(--text-primary)] mb-2">
            Digital Leader Project
          </div>
          <p className="text-sm text-[var(--text-secondary)]">
            © {new Date().getFullYear()} All rights reserved.
          </p>
        </div>

        <div className="flex gap-8 text-sm text-[var(--text-secondary)]">
          <LegalDialog label="Privacy Policy" testId="footer-privacy-policy-button">
            <PrivacyPolicy />
          </LegalDialog>
          <LegalDialog label="Terms of Service" testId="footer-terms-of-service-button">
            <TermsOfService />
          </LegalDialog>
        </div>
      </div>
    </div>
  </footer>
);
